// extracted by mini-css-extract-plugin
module.exports = {"babylon":"BabylonScene_babylon__FGIHS"};